import { createGetFullKeyEndpoint } from '@lib';
import { getQueryString } from '@sonar-software/sonar-http';
import { SonarObjectApplication } from '@types';

import { KeyPaginationQueryParams, PaginatedResource } from '@sonar-software/sonar-ts-types';

export type GetSonarObjectApplicationsRequest = KeyPaginationQueryParams & {
	sonarObjectId: number;
};

export type GetSonarObjectApplicationsResponse = PaginatedResource<SonarObjectApplication> & {
	monitored: boolean;
};

export const getSonarObjectApplications = createGetFullKeyEndpoint<
	SonarObjectApplication,
	GetSonarObjectApplicationsRequest,
	GetSonarObjectApplicationsResponse
>(({ sonarObjectId, ...rest }) => `/api/v3/core/sonar-objects/${sonarObjectId}/applications?${getQueryString({
	...rest,
	ordering: 'Name~a'
})}`);
